import { Trans, useTranslation } from 'react-i18next';
import { siteTypesEnum } from '../../../helpers';
import { useRootSelector } from '../../../store/hooks';
import { selectPageConfig } from '../../../store/features/pageConfig';
import { selectSitePartners } from '../../../store/features/sitePartners';
import './SitePartners.scss';

export default function SitePartners() {
  const { COURSE } = siteTypesEnum();
  const { t } = useTranslation();
  const { siteType } = useRootSelector(selectPageConfig);
  const { data: { allOrganisationsNames = [] } = {} } =
    useRootSelector(selectSitePartners);

  const titleId =
    siteType === COURSE
      ? 'event.trainers'
      : 'event.exhibitors-and-sponsors-header';
  const bodyId =
    siteType === COURSE ? 'course.third-party-list' : 'event.third-party-list';

  const sortedOrganisations = [...allOrganisationsNames].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' }),
  );

  return (
    <div className="event-partners">
      <h2 className="event-partners__heading">{t(titleId)}</h2>
      <p className="event-partners__body">
        <Trans i18nKey={t(bodyId)} />
      </p>
      <ul className="event-partners__list">
        {sortedOrganisations.map((partner) => (
          <li key={partner} className="event-partners__organisation-name">
            {partner}
          </li>
        ))}
      </ul>
    </div>
  );
}
